<!-- HealthInformationExchange.vue -->
<script setup lang="ts">
import { HealthInformationExchange_ConsentType } from '../../../Enums/ChoiceEnums';
import { LayoutOrientation, DateDisplayFormat } from '../../../Enums/UiEnums';
import DatePickerNoTZ from '../../../components/DatePickerNoTZ.vue';
import RadioButtonGroup from '../../../components/Inputs/RadioButtonGroup.vue';
import { IRadioButtonItem } from '../../../components/Inputs/RadioButtonGroupModels';
import SimpleFlexTable from '../../../components/Table/SimpleFlexTable.vue';
import SimpleFlexTableRow from '../../../components/Table/SimpleFlexTableRow.vue';
import { IPatientDecodeValue } from '../../../lib/Models/Patient/IPatientDecodeValue';

    const props = defineProps<{
        patientData: IPatientDecodeValue
    }>();

    enum ColIndex
    {
        Type,
        Consent
    }

    const consentRadioButtonItems: IRadioButtonItem[] = [
        { text: "Unknown", value: HealthInformationExchange_ConsentType.Unknown },
        { text: "Granted", value: HealthInformationExchange_ConsentType.Granted },
        { text: "Denied", value: HealthInformationExchange_ConsentType.Denied }
    ];

    const emits = defineEmits(["update:patientData"]);
    function emitPatientData()
    {
        emits("update:patientData", props.patientData);
    }
</script>

<style>
    .ValuesCol { flex-basis: 10em; text-align: center;}
</style>

<template>
    <SimpleFlexTable :columnClasses='["simple-cell TitleCol", "simple-cell"]'>
        <SimpleFlexTableRow rowClass="simple-row">
            <template #cell="{colIndex}">
                <template v-if="ColIndex.Type == colIndex">
                    Consent
                </template>
                <template v-if="ColIndex.Consent == colIndex">
                    <RadioButtonGroup 
                        v-model="patientData.hieConsentType" 
                        @update:modelValue="emitPatientData"
                        :items="consentRadioButtonItems" 
                        :layout="LayoutOrientation.Horz" />
                </template>
            </template>
        </SimpleFlexTableRow>

        <SimpleFlexTableRow>
            <template #cell="{colIndex}">
                <template v-if="ColIndex.Type == colIndex">
                    Effective Date
                </template>
                <template v-if="ColIndex.Consent == colIndex">
                    <DatePickerNoTZ 
                        v-model:value="patientData.hieConsentDate" 
                        @update:value="emitPatientData"
                        :displayFormat="DateDisplayFormat.NumericDashDate" 
                        :internalDataFormat="DateDisplayFormat.ISO8601"
                        :disabled="HealthInformationExchange_ConsentType.Unknown == patientData.hieConsentType" />
                </template>
            </template>
        </SimpleFlexTableRow>
    </SimpleFlexTable>    
</template>